module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-header"
  }, [_c('div', {
    staticClass: "cont"
  }, [_vm._m(0), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": "/index"
    }
  }, [_c('span', [_vm._v("关于懂窝")])])], 1), _c('div', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": "/findUs"
    }
  }, [_c('span', [_vm._v("找到我们")])])], 1), _c('div', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": "/lifeHome"
    }
  }, [_c('span', [_vm._v("懂窝生活家")])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("assets/header/logo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dea9d29e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 453
// module chunks = 0